export type DailyVerse = {
  reference: string;
  text: string;
};

export const dailyVerses: DailyVerse[] = [
  {
    reference: 'Psalm 118:24',
    text: 'This is the day that Yahweh has made. We will rejoice and be glad in it.',
  },
  {
    reference: 'Philippians 4:13',
    text: 'I can do all things through Christ, who strengthens me.',
  },
  {
    reference: 'Jeremiah 29:11',
    text: 'For I know the plans that I have for you, says Yahweh, plans for peace, and not for evil, to give you hope and a future.',
  },
  {
    reference: 'Romans 8:28',
    text: 'We know that all things work together for good for those who love God.',
  },
  {
    reference: 'Isaiah 40:31',
    text: 'But those who wait for Yahweh will renew their strength. They will mount up with wings like eagles.',
  },
  {
    reference: 'Proverbs 3:5-6',
    text: 'Trust in Yahweh with all your heart, and don’t lean on your own understanding. In all your ways acknowledge him, and he will make your paths straight.',
  },
  {
    reference: 'John 14:27',
    text: 'Peace I leave with you. My peace I give to you; not as the world gives, give I to you.',
  },
  {
    reference: '2 Timothy 1:7',
    text: 'For God didn’t give us a spirit of fear, but of power, love, and self-control.',
  },
  {
    reference: 'Psalm 46:1',
    text: 'God is our refuge and strength, a very present help in trouble.',
  },
  {
    reference: 'Matthew 11:28',
    text: 'Come to me, all you who labor and are heavily burdened, and I will give you rest.',
  },
  {
    reference: 'Lamentations 3:22-23',
    text: 'It is because of Yahweh’s loving kindnesses that we are not consumed, because his compassion doesn’t fail. They are new every morning.',
  },
  {
    reference: 'James 1:5',
    text: 'But if any of you lacks wisdom, let him ask of God, who gives to all liberally and without reproach; and it will be given to him.',
  },
  {
    reference: 'Joshua 1:9',
    text: 'Be strong and courageous. Don’t be afraid, for Yahweh your God is with you wherever you go.',
  },
  {
    reference: 'Psalm 37:4',
    text: 'Also delight yourself in Yahweh, and he will give you the desires of your heart.',
  },
  {
    reference: 'Hebrews 13:8',
    text: 'Jesus Christ is the same yesterday, today, and forever.',
  },
  {
    reference: 'Romans 15:13',
    text: 'Now may the God of hope fill you with all joy and peace in believing.',
  },
  {
    reference: '1 Peter 5:7',
    text: 'Casting all your worries on him, because he cares for you.',
  },
  {
    reference: 'Psalm 23:1',
    text: 'Yahweh is my shepherd: I shall lack nothing.',
  },
  {
    reference: 'John 8:12',
    text: 'I am the light of the world. He who follows me will not walk in the darkness, but will have the light of life.',
  },
  {
    reference: 'Galatians 6:9',
    text: 'Let us not be weary in doing good, for we will reap in due season if we don’t give up.',
  },
  { reference: 'Psalm 119:105', text: 'Your word is a lamp to my feet, and a light for my path.' },
  {
    reference: 'Ephesians 2:8',
    text: 'For by grace you have been saved through faith, and that not of yourselves; it is the gift of God.',
  },
  {
    reference: 'Micah 6:8',
    text: 'What does Yahweh require of you, but to act justly, to love mercy, and to walk humbly with your God?',
  },
  {
    reference: 'Psalm 34:8',
    text: 'Oh taste and see that Yahweh is good. Blessed is the man who takes refuge in him.',
  },
  {
    reference: 'Romans 12:2',
    text: 'Don’t be conformed to this world, but be transformed by the renewing of your mind.',
  },
  {
    reference: 'Matthew 5:16',
    text: 'Even so, let your light shine before men; that they may see your good works, and glorify your Father who is in heaven.',
  },
  {
    reference: 'Colossians 3:23',
    text: 'And whatever you do, work heartily, as for the Lord, and not for men.',
  },
  {
    reference: '1 Thessalonians 5:16-18',
    text: 'Always rejoice. Pray without ceasing. In everything give thanks.',
  },
  {
    reference: 'Psalm 121:1-2',
    text: 'I will lift up my eyes to the hills. Where does my help come from? My help comes from Yahweh, who made heaven and earth.',
  },
  {
    reference: '2 Corinthians 5:7',
    text: 'For we walk by faith, not by sight.',
  },
  {
    reference: 'Revelation 21:4',
    text: 'He will wipe away from them every tear from their eyes.',
  },
];

export function getVerseOfDay(date: Date = new Date()): DailyVerse {
  const dayOfMonth = date.getDate();
  return dailyVerses[(dayOfMonth - 1) % dailyVerses.length];
}
